<template>
  <v-container fluid class="auth-login-panel">
    <v-alert
      outline
      type="error"
      :value="error !== null"
      class="auth-login-panel__alert"
      transition="slide-y"
      >{{ error }}</v-alert
    >
    <v-form
      v-model="hasError"
      @submit.prevent="login"
      id="check-login-form"
      class="auth-login-panel__form"
    >
      <button
        type="submit"
        :disabled="loading"
        class="auth-login-panel__submit"
        :class="{ 'auth-login-panel__submit--loading': loading }"
        aria-label="Continue with Google"
      >
        <span class="auth-login-panel__button-layout">
          <span class="auth-login-panel__google-mark">
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path
                fill="#4285F4"
                d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
              />
              <path
                fill="#34A853"
                d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.24 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
              />
              <path
                fill="#FBBC05"
                d="M5.84 14.1c-.22-.66-.35-1.36-.35-2.1s.13-1.44.35-2.1V7.06H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.94l3.66-2.84z"
              />
              <path
                fill="#EA4335"
                d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06L5.84 9.9C6.71 7.3 9.14 5.38 12 5.38z"
              />
            </svg>
          </span>
          <span class="auth-login-panel__button-copy">
            <strong>{{
              loading ? "Preparing secure login" : "Continue with Google"
            }}</strong>
            <small>Use your authorized Trukkin workspace account</small>
          </span>
          <span
            v-if="loading"
            class="auth-login-panel__button-spinner"
            aria-hidden="true"
          ></span>
          <v-icon v-else class="auth-login-panel__button-arrow" aria-hidden="true">
            arrow_forward
          </v-icon>
        </span>
      </button>
    </v-form>

    <div class="auth-login-panel__trust-row">
      <span class="auth-login-panel__trust-icon">
        <v-icon>lock_outline</v-icon>
      </span>
      <p>Google SSO only. Access is protected by role permissions after sign in.</p>
    </div>
  </v-container>
</template>

<script>
import { StorageKeys, WorkingCountries } from "../../constants/constants";
import { EventBus } from "../../event-bus.js";
export default {
  data() {
    return {
      isSignIn: false,
      email: null,
      password: null,
      loading: false,
      error: null,
    };
  },
  computed: {
    hasError: {
      get() {
        return this.email === null || this.password === null;
      },
      set(val) {},
    },
  },
  methods: {
    login() {
      const { serverUrl, rbacUrl, apiUrl } = this.constants;
      this.loading = true;
      this.error = null;
      this.$gAuth
        .signIn()
        .then((user) => {
          this.loading = true;
          let googleData = user.getBasicProfile();
          // On success do something, refer to https://developers.google.com/api-client-library/javascript/reference/referencedocs#googleusergetid
          var domain = googleData
            .getEmail()
            .substring(googleData.getEmail().lastIndexOf("@") + 1);

          // if (domain != "trukkin.com" && domain != "volumetree.com") {
          //   this.setError(
          //     "You can not login with this account as you are not member of Trukkin."
          //   );
          //   this.loading = false;
          //   return;
          // }
          let webToken = localStorage.getItem("webToken");
          let obj = {};
          obj = {
            email: googleData.getEmail(),
            id: googleData.getId(),
            name: googleData.getName(),
          };
          if (webToken) {
            obj["webToken"] = webToken;
          }
          this.$http.post(`${apiUrl}/dmsAdmin/socialLogin`, obj).then(
            (response) => {
              console.log(response, "------data");

              const { statusCode, data } = response.data;
              console.log(statusCode, "------data");
              if (statusCode) {
                const { accessToken } = data;

                localStorage.setItem("user_Id", data._id);
                localStorage.setItem(StorageKeys.SessionKey, accessToken);
                localStorage.setItem("userId", data.userId);
                localStorage.setItem("activeMenu", 2);
                localStorage.setItem("user", data.name);
                // localStorage.setItem("divisions", 55);
                localStorage.setItem("role", data.roleType);
                localStorage.setItem("email", googleData.getEmail());

                // let divd = [];
                // divd.push(data.divisions);
                localStorage.setItem(
                  "divisions",
                  JSON.stringify(data.divisions.flat())
                );
                this.identify(googleData.getEmail());
                this.setPeople({
                  $email: googleData.getEmail(),
                  $name: googleData.getName(),
                });

                // ----------------- SETTING MASTER COUNTRIES FOR PLATFORM

                if (data.countrySortName.length) {
                  let accessibleCountries = [];
                  WorkingCountries.forEach((key, index) => {
                    if (data.countrySortName.indexOf(key.value) >= 0) {
                      accessibleCountries.push(key);
                    }
                  });
                  if (accessibleCountries.length) {
                    accessibleCountries[0].isSelected = true;
                    if (accessibleCountries[1]) {
                      accessibleCountries[1].isSelected = false;
                    }
                    if (accessibleCountries[2]) {
                      accessibleCountries[2].isSelected = false;
                    }
                  }
                  localStorage.setItem(
                    "workingCountries",
                    JSON.stringify(accessibleCountries)
                  );
                  EventBus.$emit("setCountries", accessibleCountries);
                } else {
                  this.setError(
                    "You do not have access to any country! Please contact admin"
                  );
                  return false;
                  this.loading = false;
                }

                EventBus.$emit("User-Id", data.userId);
                this.$http
                  .post(`${rbacUrl}/checkUserPermission`, {
                    userId: localStorage.getItem("userId"),
                  })
                  .then((res) => {
                    localStorage.setItem(
                      "permissions",
                      JSON.stringify(res.data.data)
                    );
                    if (!res.data.data) {
                      this.loading = false;
                    }
                    let router = this.$router;
                    this.loading = false;
                    localStorage.setItem("first-load", true);
                    this.$router.replace("/");
                    EventBus.$emit("logged-in-success", data);
                  })
                  .catch((e) => {
                    localStorage.removeItem("userId");
                    localStorage.removeItem("user");
                    localStorage.removeItem("role");
                    localStorage.removeItem("email");
                    localStorage.removeItem(StorageKeys.SessionKey);
                    localStorage.removeItem("workingCountries");
                    this.setError(
                      "Failed to login" +
                        (this.data && this.data.message
                          ? ":" + this.data.message
                          : "")
                    );
                    this.loading = false;
                  });
              } else {
                localStorage.removeItem(StorageKeys.SessionKey);
                localStorage.removeItem("userId");
                localStorage.removeItem("user");
                localStorage.removeItem("role");
                localStorage.removeItem("email");
                localStorage.removeItem("workingCountries");
                this.setError(
                  "Failed to login" +
                    (this.data && this.data.message
                      ? ":" + this.data.message
                      : "")
                );
                this.loading = false;
              }
            },
            (error) => {
              this.setError(error.response.data.message);

              this.loading = false;
            }
          );

          this.isSignIn = this.$gAuth.isAuthorized;
        })
        .catch((error) => {
          this.loading = false;
          this.setError("Google login failed");
        });
    },
    setError(error) {
      this.error = error;
      setTimeout(() => (this.error = null), 5000);
    },
  },
};
</script>

<style scoped>
.auth-login-panel {
  --auth-primary: #ea7a1c;
  --auth-primary-dark: #d96a10;
  --auth-blue-soft: #6e9bff;
  --auth-ink: #f4f7ff;
  --auth-muted: #98a6c6;
  color: var(--auth-ink);
  font-family: "Geist", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  overflow: visible;
  padding: 0 !important;
  position: relative;
  width: 100%;
}

.auth-login-panel__alert {
  background: rgba(69, 18, 24, 0.86) !important;
  border: 0.0625rem solid rgba(248, 113, 113, 0.4) !important;
  border-radius: 0.875rem !important;
  box-shadow: none !important;
  color: #fecaca !important;
  font-size: 0.8125rem !important;
  font-weight: 700;
  line-height: 1.5;
  margin: 0 0 1rem !important;
  padding: 0.75rem 0.875rem !important;
}

.auth-login-panel__form {
  margin: 0;
}

.auth-login-panel__submit {
  -webkit-appearance: none;
  appearance: none;
  align-items: center;
  background-color: #ea7a1c !important;
  background-image:
    linear-gradient(180deg, rgba(255, 255, 255, 0.16), transparent),
    linear-gradient(100deg, #ea7a1c, #d96a10) !important;
  border: 0;
  border-radius: 0.875rem;
  box-shadow:
    0 0.875rem 1.75rem -0.625rem rgba(234, 122, 28, 0.62),
    inset 0 0.0625rem 0 rgba(255, 255, 255, 0.24);
  color: #ffffff !important;
  cursor: pointer;
  display: flex;
  font: inherit;
  min-height: 4.375rem;
  letter-spacing: 0;
  margin: 0;
  min-width: 0;
  overflow: hidden;
  padding: 0.9375rem 1.125rem;
  position: relative;
  text-align: left;
  text-transform: none;
  transition:
    box-shadow 0.2s ease,
    filter 0.2s ease,
    transform 0.2s ease;
  width: 100%;
}

.auth-login-panel__submit::before {
  background:
    linear-gradient(90deg, rgba(255, 255, 255, 0.16), transparent 42%),
    rgba(255, 255, 255, 0.06);
  border-radius: 0.875rem;
  content: "";
  inset: 0;
  opacity: 0 !important;
  position: absolute;
  transition: opacity 0.18s ease;
}

.auth-login-panel__submit:hover:not(:disabled) {
  box-shadow:
    0 1.125rem 2.125rem -0.625rem rgba(234, 122, 28, 0.72),
    0 0 0 0.25rem rgba(234, 122, 28, 0.16);
  filter: brightness(1.04);
  transform: translateY(-0.0625rem);
}

.auth-login-panel__submit:hover:not(:disabled)::before {
  opacity: 1 !important;
}

.auth-login-panel__submit:focus {
  outline: none;
}

.auth-login-panel__submit:focus-visible {
  box-shadow:
    0 0 0 0.0625rem rgba(255, 255, 255, 0.7),
    0 0 0 0.3125rem rgba(234, 122, 28, 0.24),
    0 0.875rem 1.75rem -0.625rem rgba(234, 122, 28, 0.62);
}

.auth-login-panel__submit:disabled,
.auth-login-panel__submit--loading,
.auth-login-panel__submit.auth-login-panel__submit--loading:disabled {
  -webkit-appearance: none;
  appearance: none;
  background-color: #ea7a1c !important;
  background-image:
    linear-gradient(180deg, rgba(255, 255, 255, 0.16), transparent),
    linear-gradient(100deg, #ea7a1c, #d96a10) !important;
  box-shadow:
    0 0.875rem 1.75rem -0.625rem rgba(234, 122, 28, 0.62),
    inset 0 0.0625rem 0 rgba(255, 255, 255, 0.24) !important;
  color: #ffffff !important;
  cursor: wait;
  filter: none;
  opacity: 1 !important;
}

.auth-login-panel__submit--loading .auth-login-panel__google-mark,
.auth-login-panel__submit--loading .auth-login-panel__button-copy {
  opacity: 1;
}

.auth-login-panel__google-mark {
  align-items: center;
  align-self: center;
  background: #ffffff;
  border: 0.0625rem solid rgba(226, 232, 240, 0.9);
  border-radius: 0.75rem;
  box-shadow: 0 0.5rem 1rem rgba(23, 32, 51, 0.16);
  display: inline-flex;
  flex: 0 0 auto;
  height: 2.5rem;
  justify-content: center;
  line-height: 0;
  margin: 0 !important;
  position: static !important;
  transform: none !important;
  width: 2.5rem;
}

.auth-login-panel__google-mark svg {
  display: block;
  flex: 0 0 auto;
  height: 1.25rem;
  margin: 0 !important;
  position: static !important;
  transform: none !important;
  width: 1.25rem;
}

.auth-login-panel__button-layout {
  align-items: center;
  display: grid;
  gap: 0.875rem;
  grid-template-columns: auto minmax(0, 1fr) auto;
  justify-content: flex-start;
  justify-items: start;
  width: 100%;
}

.auth-login-panel__button-copy {
  display: grid;
  gap: 0.1875rem;
  min-width: 0;
  text-align: left;
}

.auth-login-panel__button-copy strong {
  color: #ffffff;
  display: block;
  font-size: 0.9375rem;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 1.2;
}

.auth-login-panel__button-copy small {
  color: rgba(255, 255, 255, 0.82);
  display: block;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 1.25;
  overflow-wrap: anywhere;
}

.auth-login-panel__button-arrow {
  color: #ffffff !important;
  font-size: 1.125rem;
  justify-self: end;
}

.auth-login-panel__button-spinner {
  animation: auth-button-spin 0.8s linear infinite;
  border: 0.125rem solid rgba(255, 255, 255, 0.36);
  border-top-color: #ffffff;
  border-radius: 999rem;
  height: 1.125rem;
  justify-self: end;
  width: 1.125rem;
}

.auth-login-panel__trust-row {
  align-items: flex-start;
  background: rgba(110, 155, 255, 0.07);
  border: 0.0625rem solid rgba(110, 155, 255, 0.18);
  border-radius: 0.875rem;
  color: var(--auth-muted);
  display: flex;
  gap: 0.625rem;
  margin-top: 1rem;
  padding: 0.75rem 0.875rem;
}

.auth-login-panel__trust-icon {
  align-items: center;
  color: var(--auth-blue-soft);
  display: inline-flex;
  flex: 0 0 auto;
  height: 1rem;
  justify-content: center;
  margin-top: 0.0625rem;
  width: 1rem;
}

.auth-login-panel__trust-icon .v-icon {
  color: var(--auth-blue-soft);
  font-size: 0.9375rem;
}

.auth-login-panel__trust-row p {
  color: var(--auth-muted);
  font-size: 0.78125rem;
  font-weight: 700;
  line-height: 1.5;
  margin: 0;
}

@media (max-width: 30rem) {
  .auth-login-panel__submit {
    min-height: 4.125rem;
    padding: 0.8125rem 0.875rem;
  }

  .auth-login-panel__google-mark {
    height: 2.375rem;
    width: 2.375rem;
  }

  .auth-login-panel__button-layout {
    gap: 0.6875rem;
  }

  .auth-login-panel__button-arrow {
    display: none;
  }

  .auth-login-panel__button-copy strong {
    font-size: 0.875rem;
  }

  .auth-login-panel__button-copy small {
    font-size: 0.6875rem;
  }
}

@media (max-width: 23.75rem) {
  .auth-login-panel__submit {
    min-height: 0;
    padding: 0.75rem;
  }

  .auth-login-panel__button-layout {
    gap: 0.625rem;
    grid-template-columns: auto minmax(0, 1fr);
  }

  .auth-login-panel__button-spinner {
    display: none;
  }

  .auth-login-panel__google-mark {
    height: 2.125rem;
    width: 2.125rem;
  }

  .auth-login-panel__google-mark svg {
    height: 1.125rem;
    width: 1.125rem;
  }

  .auth-login-panel__trust-row {
    padding: 0.6875rem 0.75rem;
  }
}

@keyframes auth-button-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>

<style>
#nav.auth-route-shell .auth-login-panel__submit,
#nav.auth-route-shell .auth-login-panel__submit:disabled,
#nav.auth-route-shell .auth-login-panel__submit--loading,
#nav.auth-route-shell button.auth-login-panel__submit[disabled],
.application #nav.auth-route-shell button.auth-login-panel__submit[disabled] {
  -webkit-appearance: none !important;
  appearance: none !important;
  background: #ea7a1c !important;
  background-image:
    linear-gradient(180deg, rgba(255, 255, 255, 0.16), transparent),
    linear-gradient(100deg, #ea7a1c, #d96a10) !important;
  border: 0 !important;
  color: #ffffff !important;
  opacity: 1 !important;
}

#nav.auth-route-shell .auth-login-panel__submit .auth-login-panel__button-copy,
#nav.auth-route-shell .auth-login-panel__submit .auth-login-panel__button-copy strong,
#nav.auth-route-shell .auth-login-panel__submit .auth-login-panel__button-copy small,
#nav.auth-route-shell button.auth-login-panel__submit[disabled] .auth-login-panel__button-copy,
#nav.auth-route-shell button.auth-login-panel__submit[disabled] .auth-login-panel__button-copy strong,
#nav.auth-route-shell button.auth-login-panel__submit[disabled] .auth-login-panel__button-copy small {
  color: #ffffff !important;
}
</style>
